export const generateAppConfig = () => {
  let exportResult = {
    appRepoLocation: "http://localhost:3000",
    backendUrl: "http://localhost:3100",
    appBackendUrl: "http://localhost:4040",
    jsReportUrl: "http://localhost:5488",
  };
  if (process.env.REACT_APP_PRODUCTION_MODE === "TEST") {
    exportResult.appRepoLocation = "https://sg-app.summercruise.com.my";
    exportResult.backendUrl = "https://sg-api.summercruise.com.my/admin";
    exportResult.appBackendUrl = "https://sg-api.summercruise.com.my/app";
    exportResult.jsReportUrl = "https://sg-report.summercruise.com.my";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "STAGE") {
    exportResult.appRepoLocation = "https://app.travoxis.com";
    exportResult.backendUrl = "https://admin-api.travoxis.com";
    exportResult.appBackendUrl = "https://app-api.travoxis.com";
    exportResult.jsReportUrl = "https://sg-report.summercruise.com.my";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "PROD") {
    exportResult.appRepoLocation = "https://app.summercruise.com.my";
    exportResult.backendUrl = "https://api.summercruise.com.my/admin";
    exportResult.appBackendUrl = "https://api.summercruise.com.my/app";
    exportResult.jsReportUrl = "https://report.summercruise.com.my";
  }
  return exportResult;
};
